import React from 'react';
import whitePawn from '../assets/Pieces/whitePawn.png';
import blackPawn from '../assets/Pieces/blackPawn.png';
import whiteBishop from '../assets/Pieces/whiteBishop.png';
import blackBishop from '../assets/Pieces/blackBishop.png';
import whiteKnight from '../assets/Pieces/whiteKnight.png';
import blackKnight from '../assets/Pieces/blackKnight.png';
import whiteRock from '../assets/Pieces/whiteRock.png';
import blackRock from '../assets/Pieces/blackRock.png';
import whiteQueen from '../assets/Pieces/whiteQueen.png';
import blackQueen from '../assets/Pieces/blackQueen.png';
import whiteKing from '../assets/Pieces/whiteKing.png';
import blackKing from '../assets/Pieces/blackKing.png';

const pieceImages = {
  pawn: { white: whitePawn, black: blackPawn },
  bishop: { white: whiteBishop, black: blackBishop },
  knight: { white: whiteKnight, black: blackKnight },
  rook: { white: whiteRock, black: blackRock },
  queen: { white: whiteQueen, black: blackQueen },
  king: { white: whiteKing, black: blackKing },
};

const Piece = ({ type, color, isSelected = false }) => {
  const imageSrc = pieceImages[type]?.[color];
  if (!imageSrc) return null;

  return (
    <img
      src={imageSrc}
      alt={`${color} ${type}`}
      className={`piece-image${isSelected ? ' piece-image--selected' : ''}`}
      draggable="false"
    />
  );
};

export default Piece;
